import React from 'react'
import { HeaderPrivate } from '../../components/HeaderPrivate'
import { PrivateTitleBar } from '../../components/PrivateTitleBar'
import { PrivateFooter } from '../../components/PrivateFooter'
import { DashboardNav } from '../../components/DashboardNav'

export const PrivateFavorites = () => {
    return (
        <>
            <HeaderPrivate />
            <div id="dashboard">
                <a href="#" className="dashboard-responsive-nav-trigger"><i className="fa fa-reorder"></i> Dashboard Navigation</a>
                <DashboardNav selectedMenu="favorites" />

                {/* <!-- Content==== --> */}
                <div className="dashboard-content">

                    <PrivateTitleBar title="Mis favoritos" />

                    <div className="row">

                        {/* <!-- Listings --> */}
                        <div className="col-lg-12 col-md-12">
                            <div className="dashboard-list-box margin-top-0">
                                <h4>Bookmarked Listings</h4>
                                <ul>

                                    <li>
                                        <div className="list-box-listing">
                                            <div className="list-box-listing-img"><a href="#"><img src="images/listing-item-02.jpg" alt="" /></a></div>
                                            <div className="list-box-listing-content">
                                                <div className="inner">
                                                    <h3>Sticky Band</h3>
                                                    <span>Bishop Avenue, New York</span>
                                                    <div className="star-rating" data-rating="5.0">
                                                        <div className="rating-counter">(23 reviews)</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="buttons-to-right">
                                            <a href="#" className="button gray"><i className="sl sl-icon-close"></i> Delete</a>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="list-box-listing">
                                            <div className="list-box-listing-img"><a href="#"><img src="images/listing-item-04.jpg" alt="" /></a></div>
                                            <div className="list-box-listing-content">
                                                <div className="inner">
                                                    <h3>Burger House</h3>
                                                    <span>2726 Shinn Street, New York</span>
                                                    <div className="star-rating" data-rating="5.0">
                                                        <div className="rating-counter">(31 reviews)</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="buttons-to-right">
                                            <a href="#" className="button gray"><i className="sl sl-icon-close"></i> Delete</a>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="list-box-listing">
                                            <div className="list-box-listing-img"><a href="#"><img src="images/listing-item-06.jpg" alt="" /></a></div>
                                            <div className="list-box-listing-content">
                                                <div className="inner">
                                                    <h3>Think Coffee</h3>
                                                    <span>215 Terry Lane, New York</span>
                                                    <div className="star-rating" data-rating="5.0">
                                                        <div className="rating-counter">(31 reviews)</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="buttons-to-right">
                                            <a href="#" className="button gray"><i className="sl sl-icon-close"></i> Delete</a>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                        </div>

                        <PrivateFooter />
                    </div>
                </div>
                {/* <!-- Content / End --> */}
            </div>
        </>
    )
}